/**
 * @generated SignedSource<<b40ae38942a5b938bcb73691a2b75002>>
 * @relayHash 7de130ea996241735986cdfa83620b3a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0a5d42f9dcff48d113d89112783d0430391298268b28ba9e3e274438c2972e91

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceTrackSource = "MOBILE" | "UNKNOWN" | "WEB" | "%future added value";
export type ConfluenceTrackSourceInput = "MOBILE" | "WEB" | "%future added value";
export type ConfluenceTrackType = "BRIEFING" | "NARRATION" | "%future added value";
export type ConfluenceAddTrackInput = {
  top?: boolean | null | undefined;
  track: ConfluenceTrackInput;
};
export type ConfluenceTrackInput = {
  mainSource: string;
  supportingSources?: ReadonlyArray<string> | null | undefined;
  trackSource?: ConfluenceTrackSourceInput | null | undefined;
  trackType: ConfluenceTrackType;
};
export type useContextMenuActionsAddTrackMutation$variables = {
  cloudId: string;
  input: ConfluenceAddTrackInput;
};
export type useContextMenuActionsAddTrackMutation$data = {
  readonly confluence_addTrack: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
    readonly track: {
      readonly id: string;
      readonly mainContent: {
        readonly history: {
          readonly createdBy: {
            readonly displayName: string | null | undefined;
            readonly profilePicture: {
              readonly path: string;
            } | null | undefined;
          } | null | undefined;
          readonly ownedBy: {
            readonly displayName: string | null | undefined;
            readonly profilePicture: {
              readonly path: string;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly links: {
          readonly base: string | null | undefined;
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly space: {
          readonly key: string | null | undefined;
        } | null | undefined;
        readonly status: string | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly mainSource: string;
      readonly supportingContent: ReadonlyArray<{
        readonly ari: string | null | undefined;
        readonly links: {
          readonly base: string | null | undefined;
          readonly webui: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly supportingSources: ReadonlyArray<string> | null | undefined;
      readonly trackSource: ConfluenceTrackSource | null | undefined;
      readonly type: ConfluenceTrackType;
    } | null | undefined;
  } | null | undefined;
};
export type useContextMenuActionsAddTrackMutation = {
  response: useContextMenuActionsAddTrackMutation$data;
  variables: useContextMenuActionsAddTrackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "ConfluenceAddTrackPayloadError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    },
    {
      "concreteType": "ConfluenceAddTrackPayloadErrorExtension",
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "statusCode"
        }
      ]
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
},
v6 = {
  "kind": "ScalarField",
  "name": "mainSource"
},
v7 = {
  "kind": "ScalarField",
  "name": "trackSource"
},
v8 = {
  "kind": "ScalarField",
  "name": "supportingSources"
},
v9 = {
  "kind": "ScalarField",
  "name": "ari"
},
v10 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "base"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "title"
},
v12 = {
  "kind": "ScalarField",
  "name": "status"
},
v13 = {
  "kind": "ScalarField",
  "name": "subType"
},
v14 = {
  "kind": "ScalarField",
  "name": "key"
},
v15 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v16 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v17 = [
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\"])"
},
v19 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v15/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContextMenuActionsAddTrackMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceAddTrackPayload",
        "kind": "LinkedField",
        "name": "confluence_addTrack",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "ConfluenceTrack",
            "kind": "LinkedField",
            "name": "track",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "supportingContent",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/)
                ]
              },
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "mainContent",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v11/*: any*/),
                  (v5/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v10/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v17/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": (v17/*: any*/)
                      }
                    ]
                  },
                  (v18/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContextMenuActionsAddTrackMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceAddTrackPayload",
        "kind": "LinkedField",
        "name": "confluence_addTrack",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "ConfluenceTrack",
            "kind": "LinkedField",
            "name": "track",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "supportingContent",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "mainContent",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v11/*: any*/),
                  (v5/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v10/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v19/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": (v19/*: any*/)
                      }
                    ]
                  },
                  (v18/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0a5d42f9dcff48d113d89112783d0430391298268b28ba9e3e274438c2972e91",
    "metadata": {},
    "name": "useContextMenuActionsAddTrackMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0981d661679191cac56da39dadd5e417";

export default node;
